import React from 'react';
import Link from '../Link';
import styles from './styles.module.scss';

const PostFuckingFooter = () => {

  return (<>
    <div className={styles.cont}>
      <p>Powered by {``}
        <Link
          className={styles.btnHdp}
          href="https://spiral-studio.com/"
          external={true}
        >Spiral Studio
        </Link>
      </p>
    </div>
  </>);
};

export default PostFuckingFooter;
